import { useCallback } from "react";
import { createFileRoute, useNavigate } from "@tanstack/react-router";

import { PairingScreen } from "~/components/station/pairing-screen";
import { setBorneDeviceToken } from "~/lib/borne/device-token";
import { BORNE_PATHS } from "~/lib/borne/route";

export const Route = createFileRoute("/borne/appairage")({
  component: BornePairingPage,
});

function BornePairingPage() {
  const navigate = useNavigate();
  const onToken = useCallback(
    async (token: string) => {
      setBorneDeviceToken(token);
      await navigate({ to: BORNE_PATHS.idle, replace: true });
    },
    [navigate],
  );
  return (
    <PairingScreen
      scope="borne"
      title={
        <>
          Enregistrez
          <br />
          cette borne.
        </>
      }
      lead="Saisissez ce code dans la console Gately et choisissez « Borne d'accueil »."
      onToken={onToken}
    />
  );
}
